// extracted by mini-css-extract-plugin
module.exports = {"tabSelector":"TabSelector_tabSelector__FeV2M","active":"TabSelector_active__d9u2q","small":"TabSelector_small__z0Tse","disabled":"TabSelector_disabled__laA0m"};